window.service_pagination = function (form_id, total_num, callback, pagination_id, page_count) {

    page_count = coalesce(page_count, 5);
    pagination_id = coalesce(pagination_id, 'pagination');

    if (total_num == 0) {
        $("#" + pagination_id).html("");
        return;
    }

    var page_num = coalesce($("#" + form_id + ' [name="page_num"]').val(), 1);
    var list_count = coalesce($("#" + form_id + ' [name="list_count"]').val(), 10);

    var total_page_num = Math.ceil(total_num / list_count);
    var start_page_num = Math.ceil(page_num / page_count) * page_count - page_count + 1;
    var end_page_num = start_page_num + page_count - 1;

    if (total_page_num < end_page_num) {
        end_page_num = total_page_num;
    }

    var previous_page_num = start_page_num - 1;
    var next_page_num = end_page_num + 1;

    var row = '';
    row += '<nav class="mt-2">';

    row += '<ul class="pagination justify-content-center">';

    // first & previous
    if (parseInt(page_num) -1 <= 0) {
        row += '<li class="page_item disabled"><a class="page_arrow" href="javascript:void(0)"><img src="/project/meeting/images/common/pagination/arrow_left.png" class="h-100" /></a></li>';
    } else {
        row += '<li class="page_item"><a class="page_arrow" href="#" data-page-num=' + (parseInt(page_num) - 1) + '><img src="/project/meeting/images/common/pagination/arrow_left.png" class="h-100" /></a></li>';
    }

    for (var i = start_page_num; i <= end_page_num; i++) {
        if (parseInt(page_num) === parseInt(i))
            row += '<li class="page_item active font-weight-bold"><a class="page_link" href="#" data-page-num=' + i + '>' + i + '</li>';
        else
            row += '<li class="page_item"><a class="page_link" href="#" data-page-num=' + i + '>' + i + '</li>';
    }

    // last & next
    if ((parseInt(page_num) + 1) > total_page_num) {
        row += '<li class="page_item disabled"><a class="page_arrow" href="javascript:void(0)"><img src="/project/meeting/images/common/pagination/arrow_right.png" class="h-100" /></a></li>';
    } else {
        row += '<li class="page_item"><a class="page_arrow" href="#" data-page-num=' + (parseInt(page_num) + 1) + '><img src="/project/meeting/images/common/pagination/arrow_right.png" class="h-100" /></a></li>';
    }
    row += '</ul>';

    row += '</nav>';

    $("#" + pagination_id).html(row);
    $("#" + pagination_id + " a").click(function () {
        if ($(this).data("page-num")) {
            $("#" + form_id + ' [name="page_num"]').val($(this).data("page-num"));
            callback();
        }
    });
};
